import { render, staticRenderFns } from "./marca_empresarial_page.vue?vue&type=template&id=226d2f0a&scoped=true"
import script from "./marca_empresarial_page.vue?vue&type=script&lang=js"
export * from "./marca_empresarial_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d2f0a",
  null
  
)

export default component.exports